var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlovakiaEklubKeno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.45 21.576h52.124c3.43 0 5.712 2.744 5.058 6.095l-8.663 44.658c-.654 3.351-3.989 6.095-7.419 6.095H18.425c-3.43 0-5.712-2.744-5.058-6.095l8.663-44.658c.654-3.351 3.989-6.095 7.419-6.095z",
    fill: "#c61825"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.491 42.27h27.953c4.451 0 7.403 3.558 6.557 7.882-.83 4.34-5.169 7.898-9.605 7.898H56.51l-2.425 12.493c-.83 4.324-5.169 7.882-9.605 7.882-4.467 0-7.403-3.558-6.573-7.882l2.425-12.493h-5.887c-4.451 0-7.403-3.558-6.557-7.898.83-4.324 5.153-7.882 9.605-7.882z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.662 45.509h14.567c3.574 1.723 3.319 4.866 2.569 9.302l-3.223 16.641c-.495 2.553-3.047 4.643-5.68 4.643-2.617 0-4.356-2.09-3.861-4.643l3.239-16.641H34.86c-2.633 0-4.372-2.09-3.861-4.659.495-2.553 3.047-4.643 5.664-4.643zm15.588 0h12.78c2.617 0 4.356 2.09 3.861 4.643-.495 2.553-3.047 4.659-5.68 4.659h-6.318c.542-2.202.367-7.786-4.643-9.302z",
    fill: "#0f2057"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.329 21.576c5.855 0 9.716 4.627 8.6 10.355-1.101 5.712-6.749 10.339-12.604 10.339-5.871 0-9.716-4.627-8.6-10.339 1.101-5.728 6.749-10.355 12.604-10.355z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.77 24.464c4.228 0 7.02 3.351 6.206 7.467-.798 4.116-4.882 7.467-9.11 7.467-4.244 0-7.02-3.351-6.206-7.467.798-4.132 4.882-7.467 9.11-7.467z",
    fill: "#0f2057"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.292 26.395c1.42 0 2.345 1.117 2.09 2.505a3.239 3.239 0 0 1-3.047 2.505c-1.42 0-2.345-1.117-2.09-2.505s1.627-2.505 3.047-2.505z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlovakiaEklubKeno);
export default __webpack_public_path__ + "static/media/slovakia_eklub_keno.287613ebdd32b339fa5bd3161e73c633.svg";
export { ForwardRef as ReactComponent };